import {Navigate, Outlet, useLocation} from 'react-router-dom'
import React from 'react'
import {useGetCurrentUserQuery} from 'store/Store'
import PageLoader from 'components/Display/Loader/PageLoader'
import {hasPermission} from 'services/utils/permissionHelpers'
import {getMenuSiteByRole} from 'constants/sideMenu'

const ProtectedRoute = ({..._restOfProps}) => {
    const {data, error, isLoading} = useGetCurrentUserQuery()

    return isLoading || (data?.email && !(error?.status === 401)) ? (
        <Outlet />
    ) : (
        <Navigate replace to="/login" />
    )
}

const OutRoute = ({..._restOfProps}) => {
    const {data, error, isLoading} = useGetCurrentUserQuery()
    return isLoading || !data?.email || error?.status === 401 ? (
        <Outlet />
    ) : (
        <Navigate replace to="/dashboard" />
    )
}

const AccessGuard = ({children, resource}) => {
    useLocation()
    const {data, isLoading} = useGetCurrentUserQuery()
    if (isLoading) {
        return <PageLoader show={true} />
    }
    const {account, isSuperUser} = data || {}
    if (!account && !isSuperUser) {
        return <Navigate to="/sites" replace />
    }
    console.log({data, resource})

    if (resource && !hasPermission(data, resource, 'READ')) {
        return <Navigate to="/dashboard" replace />
    }

    return <>{children}</>
}

const AccountSelected = ({children, resource}) => {
    useLocation()
    const {data, isLoading} = useGetCurrentUserQuery()
    if (isLoading) {
        return <PageLoader show={true} />
    }
    const {account, user} = data || {}
    const sideMenu = getMenuSiteByRole(user, account)

    if (account) {
        return <Navigate to={`/${sideMenu[0]?.text || 'dashboard'}`} />
    }
    if (resource && !hasPermission(data, resource, 'READ')) {
        return <Navigate to="/dashboard" replace />
    }

    return <>{children}</>
}

const SuperUserGuard = ({children}) => {
    useLocation()
    const {data, isLoading} = useGetCurrentUserQuery()
    if (isLoading) {
        return <PageLoader show={true} />
    }

    if (!data?.isSuperUser) {
        return <Navigate to="/dashboard" replace />
    }

    return <>{children}</>
}

const RouteManager = {ProtectedRoute, OutRoute, AccessGuard, AccountSelected, SuperUserGuard}

export default RouteManager
